export default {
  namespaced: true,
  state: {
    goodNameRules: [],
    goodsItemUpdate: {}
  },
  getters: {
    getNameRules: state => {
      return state.goodNameRules;
    },
    getGoodsItemUpdate: state => {
      return state.goodsItemUpdate;
    }
  },
  mutations: {
    setNameRules(state, goodNameRules) {
      state.goodNameRules = goodNameRules;
    },
    setGoodsItemUpdate(state, goodsItemUpdate) {
      state.goodsItemUpdate = goodsItemUpdate;
    }
  }
};
